<template>
	<Layout>
		<div class="loading py-5" v-if="loading">
            <div class="text-center">
               <img src="/design/sigofood-images/loading-gif.gif" alt="loading">
               <p>Loading...</p>
            </div>
      </div>
		<div class="container-sm page my-3 py-3 checkout">
			<form @submit.prevent="confirm_place_order=true">
				<div class="container order px-4">
					<div class="row">
						<div class="col">
							<h4 class="order-summary">Order Summary</h4>
						</div>
						<div class="col text-end edit-order">
							<router-link :to="{ name: 'cart' }"  class="edit_link">Edit order</router-link>						
						</div>
					</div>
				</div>
				<div class="container items px-4" v-if="cart.length">
					<h5 class="diary-queen">{{cart[0].restaurant}}</h5><br>
					<b-table-simple small responsive>    
    					<b-thead head-variant="light">
      					<b-tr>
      						<b-th class="item head">
      							<p class="">Item(s)</p>
      						</b-th>
        						<b-th class="item head">
        							<p class="numeric">Offer</p>
        						</b-th>
        						<b-th class="item head">
        							<p class="numeric">Qty</p>
        						</b-th>
        						<b-th class="item head">
        							<p class="numeric">Price</p>
        						</b-th>
        						<b-th class="item head">
        							<p class="numeric">Total</p>
        						</b-th>
      					</b-tr>
    					</b-thead>
    					<b-tbody>
      					<b-tr v-for="(item, index) in cart" :key="index">
        						<b-td>
        							<p class="fw-semibold">{{item.product_name}}
									<span class="d-block" v-for="(choice, i) in item.extras" :key="i"><sub>{{choice.cat_name}}</sub></span></p>
								</b-td>
								<b-td class="item body">
									<p class="numeric">{{item.offer_price}}</p>
								</b-td>
								<b-td class="item body">
									<p class="numeric">{{item.quantity}}</p>
								</b-td>
								<b-td class="item body">
									<p class="numeric">{{item.price}}BHD</p>
								</b-td>
								<b-td class="item body">
									<p class="numeric">{{item.total}}BHD</p>
								</b-td>
      					</b-tr>
      				</b-tbody>
      			</b-table-simple>
				</div>
				<div class="container cultery d-flex px-4 py-4">
					
					<b-form-checkbox
				      id="chk-no-cutlery"
				      v-model="no_Cutlery"
				      name="chk-no-cutlery"
				      value="1"
				      unchecked-value="0"
				      class = "no-cultery"
				   >
				      <span class="ms-1">No Cultery</span>
				   </b-form-checkbox>
				</div>

				<div class="row px-4 pt-4">
					<div class="col" style="max-width: 30px;">
						<img src="/design/sigofood-images/notes.png" class="">
					</div>
					<div class="col">
						<div class="row">
							<div class="col-12">
								<p class="mb-0">Notes<span class="d-block"><sub>input allergies, delivery notes here</sub></span> </p>
							</div>
							<div class="col-12 mb-1 notes">
								<input type="text" class="form-control form-control1 form-control-sm"  placeholder="" v-model="delivery_notes">
							</div>
						</div>
					</div>				
				</div>

				<!-- <div class="">
					<div class="row" >
						<div class="col-1 text-end">
							<img src="/design/sigofood-images/voucher.png">
						</div>
						<div class="col">
							<p>Voucher<span class="d-block"><sub>Add your Voucher here</sub></span></p>
						</div>
						<div class="col">
							<div class="text-end change">
								
								<a href="javascript:void(0);" class="edit_link"  @click="applyCoupon(subtotal,offer_code)">Apply</a>
							</div>
						</div>
						<div class="mb-2 notes">
							<div class="row">
								<div class="col-xl-6">
									<div class="col">
										<input type="text" class="form-control form-control1 form-control-sm"   placeholder="Enter your voucher code" v-model="offer_code">		
									</div>
								</div>
								<div class="col-xl-6">
									<div class="col" v-if="sub_total">
										<div v-if="voucher_aaply.status == true">
											<span style="font-size: medium; color: rgb(43, 209, 43); margin-left: 10px;">{{messages}}</span>
										</div>
										<div v-else>
											<span style="font-size: medium; color: rgb(245, 7, 7); margin-left: 10px;">{{messages}}</span>
										</div>
											
									</div>
								</div>
							</div>
						</div>
					</div>
				</div><br> -->

				<div class="row px-4 py-4">
					<div class="col" style="max-width: 30px;">
						<img src="/design/sigofood-images/voucher.png">
					</div>
					<div class="col">
						<div class="row">
							<div class="col-12">
								<p class="mb-0">Voucher
									<a href="javascript:void(0);" class="edit_link float-end"  @click="applyCoupon(subtotal,offer_code)">Apply</a>
								</p>
								<p class="mb-0"><span class="d-block"><sub>Add your Voucher here</sub></span></p>
							</div>
							<div class="col-12 mb-1 notes">
								<div class="row">
									<div class="col-xl-12">
										<div class="col">
											<input type="text" class="form-control form-control1 form-control-sm"   placeholder="" v-model="offer_code">		
										</div>
									</div>
									<div class="col-xl-12">
										<div class="col" v-if="sub_total">
											<div v-if="voucher_aaply.status == true">
												<span style="font-size: medium; color: rgb(43, 209, 43); margin-left: 10px;">{{messages}}</span>
											</div>
											<div v-else>
												<span style="font-size: medium; color: rgb(245, 7, 7); margin-left: 10px;">{{messages}}</span>
											</div>
												
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>				
				</div>

				<div class="container order">
					<h4 class="order-summary">Delivery Address</h4>
				</div>
				<div class="container location"><br>

					<!-- <GmapMap v-if="marker.position.lat && marker.position.lng"
	            :center="center"
	            :zoom="18"
	            map-style-id="roadmap"
	            :options="mapOptions"
	            style="width: 100%; height: 200px"
	            ref="mapRef">                              
	               <GmapMarker
	               :position="marker.position"
	               :clickable="false"
	               :draggable="false"                                    
	               />
	            </GmapMap>    -->
				<div class="gmap_canvas">
                    <iframe class="gmap_iframe" width="100%" height="50%" frameborder="0" scrolling="no" marginheight="0"
                        marginwidth="0" :src="getMapUrl()"></iframe >
                </div>

				<div class="">
					<div class="row" style="margin-top: 5px;">
						<div class="col">
							<p class="fw-semibold">{{address.name}}</p>
							<div style="font-weight: bold; margin-bottom: 5px;">{{address.area}}</div>
							<p>{{address.building_no}}/{{address.block_no}},{{address.flat}}, {{address.road_no}} </p>
							<p>+973 {{address.mobile}}</p>
						</div>
						<div class="col">
							<div class="text-end changes" style="margin-top: 5px;">
								<router-link :to="{ name: 'cart' }"  class="edit_link">Change</router-link>
							</div>
						</div>
					</div>
				</div>
				
				</div>				

				<div class="container px-4 py-4">
					
					<b-form-checkbox
				      id="chk-contactless"
				      v-model="contactless"
				      name="chk-contactless"
				      value="1"
				      unchecked-value="0"
				      class = "no-cultery"
				      @change="changeContactless()"
				   >
				   	<div class="ms-1">
				   		<p class="mb-0"><strong>Contactless Delivery</strong></p>
				      	<p class="mb-0 small">Leave order at doorstep and inform me</p>
				      	<p class="mb-0"><sub class="">Not applicable with cash payment</sub> </p>
				      </div>
				   </b-form-checkbox>
				</div>

				<div class="delivery px-4 py-4">
					<h5 style="font-weight: 600;">Delivery Types</h5>				

					<div class=" row">
						<div class="col-xl-3">
							<div class="radio-block m-0 ">
								<div class="radio-outer">
									<input type="radio" name="delivery_type" id="door-delivery" value="DoorDelivery" v-model="delivery_type">
									<label for="door-delivery"></label>
								</div>
								<label>Door delivery</label>
							</div>
						</div>
						<div class="col-xl-3">
							<div class="radio-block m-0 ">
								<div class="radio-outer">
									<input type="radio" name="delivery_type" id="self-pickup"  value="SelfPickup" v-model="delivery_type">
									<label for="self-pickup"></label>
								</div>
								<label>Self Pickup</label>
							</div>
						</div>

					</div>		

				</div><br>
				<div class="delivery">
					<h4 class="order-summary">Pay With</h4>
					<div class="pay pay2">
						<div class="form-check" style="padding-left: 10px;">
							<div class="radio-block m-0 ">
								<div class="radio-outer">
									<input type="radio" name="payment_method" id="cash"   value="1" v-model="payment_method" @change="changeCash()" :disabled="contactless">
									<label for="cash"></label>
								</div>
								
								<img src="/design/sigofood-images/cash2.png" class="cash-icon ms-2 me-2">
								<label class="form-check-label ms-1">
									Cash
								</label>
							</div>

							<div class="radio-block m-0 ">
								<div class="radio-outer">
									<input type="radio" name="payment_method" id="online"   value="2"  v-model="payment_method" @change="contactless=1">
									<label for="online"></label>
								</div>
								
								<!-- <img src="/design/sigofood-images/cash.png" class="cash-icon ms-2 me-2"> -->
								<i class="material-icons cash-icon ms-2 me-2">payment</i>
								<label class="form-check-label ms-1">
									Online
								</label>
							</div>


						</div>
					</div>

				</div><br>
				<div class="alert alert-warning" role="alert" v-if="contactless==1"> 
					<small>Uncheck contactless delivery to use cash payment</small>
				</div>

				<div class="container order">
					<h4 class="order-summary">Payment Summary</h4>
				</div>

				<div class="container payment-summary">
					<div class="row">
						<div class="col-xl">
							<div class="row">
								<div class="col">
									<p class="payment fw-semibold">Subtotal</p>
								</div>
								<div class="col" v-if="sub_total">
									<p class="payment fw-semibold">BHD {{sub_total}} <span style="font-size: x-small; color: orange; margin-left: 10px;">Your voucher was applied successfully.</span></p>
								</div>
								<div class="col" v-else>
									<p class="payment fw-semibold">BHD {{subtotal}}</p>
								</div>
							</div>
							<div class="row">
								<div class="col">
									<p class="payment fw-semibold">Delivery Fee (<small>VAT included</small>)</p>
								</div>
								<div class="col">
									<p class="payment fw-semibold" v-if="this.cart.length">BHD {{this.cart[0].delivery_charge}}</p>
								</div>
							</div>
							<div class="row">
								<div class="col">
									<p class="fw-semibold total-amount">Total Amount</p>
								</div>
								<div class="col" v-if="sub_total">
									<p class=" fw-semibold total-amount amount">BHD {{(parseFloat(this.cart[0].delivery_charge)+ parseFloat(sub_total)).toFixed(2)}}</p>
								</div>
								<div class="col" v-else>
									<p class=" fw-semibold total-amount amount">BHD {{(parseFloat(this.cart[0].delivery_charge)+ parseFloat(subtotal)).toFixed(2)}}</p>
								</div>
							</div>

						</div>

						<div class="col-xl">
							<p class="fw-semibold total-amount">Schedule</p>
							<div class="row">
								<div class="col">
									<p class="payment fw-semibold">Delivery Date</p>
								</div>
								<div class="col">
									<!-- <b-input-group class="mb-3">
      								<b-form-input id="delivery-date" v-model="delivery_date" type="text" placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
      								<b-input-group-append>
        									<b-form-datepicker v-model="delivery_date" button-only right locale="en-US" aria-controls="delivery-date"></b-form-datepicker>
      								</b-input-group-append>
    								</b-input-group> -->
    								<b-form-datepicker id="delivery-date" v-model="delivery_date" size="sm"></b-form-datepicker>
								</div>
							</div>
							<div class="row">
								<div class="col">
									<p class="payment fw-semibold">Delivery Time</p>
								</div>
								<div class="col">
									<b-form-timepicker v-model="delivery_time" locale="en" size="sm"></b-form-timepicker>
								</div>
							</div>

						</div>  
					</div><br>

					<div class="row">
						<div class="col-xl-4">
							<div class="d-grid mx-auto" style="margin-bottom: 10px;">
								<button class="btn place-order" type="submit">Place Order</button>
							</div>
						</div>
						<div class="col">
							<div class="alert alert-warning" role="alert" v-if="confirm_place_order">
							
								<div class="row">
									<div class="col">
										<small>Do you want to place this order?</small>  
									</div>
									<div class="col-2">
										<span class="text-end yes-no " data-bs-toggle="modal" data-bs-target="#exampleModal2" @click="checkout"><small>Yes</small></span>
									</div>

									<div class="col-1">
										<span class="text-center yes-no" @click="confirm_place_order=false"><small>No</small></span>
									</div>
								</div>
							
							</div>
						</div>
					</div>


				</div>
			</form>	
		</div>
	</Layout>
</template>

<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";
import moment from 'moment'

export default {
	components: {
		Layout
	},

	data () {
		return {
		  publicPath: process.env.BASE_URL,
		  style: null,
		  token: "",
		  device_token: "",

		  	marker: { position: { lat: null, lng: null } },
         center: { lat: null, lng: null },
         current_place: null,
         location: "",

         mapOptions: {
            disableDefaultUI: true,
         },

         payment_method: 1,
         delivery_notes: '',
         offer_code: '',
         branch_id: '',
         no_Cutlery: 0,
         delivery_date: '',
         delivery_time: '',
         delivery_type: 'DoorDelivery',
         delivery_charge: '',
         service_charge: '',
         subtotal: '',
         grandtotal: '',
         block_no: '',
         contactless: 0,
		 sub_total: '',

         cart: {},
         address: {},
		 place_order: false,
		 confirm_place_order: false,
		 loading: false,
		}
	},
	created() {
		//alert(this.publicPath);

		this.style = document.createElement('link')
		this.style.setAttribute('rel', 'stylesheet')
		this.style.setAttribute('href', '/design/checkout.css')
		document.head.appendChild(this.style)
	},

	beforeDestroy() {
		document.head.removeChild(this.style);
	},

	mounted() {
		this.fetchAddress();
		this.fetchCart();
		this.getLocation();
		//this.getToken();
	},

	methods: {

		// getToken() {
		// 	if (localStorage.getItem('sigofood_user')) {
		// 		var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
		// 		if(sigofood_user.token) {
		// 			this.token = sigofood_user.token;

		// 		} else {
		// 			this.getGuest();
		// 		}

		// 	} else {
		// 		this.getGuest();
		// 	}
		// }, 

		// getGuest() {

		// 	if (localStorage.getItem('sigofood_guest')) {
		// 		var sigofood_guest =  JSON.parse(localStorage.getItem('sigofood_guest'));
		// 		this.device_token = sigofood_guest.token;
		// 		console.log(sigofood_guest)
		// 	}
		// },
		getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				console.log(sigofood_user);
				if(sigofood_user.token) {
					this.token = sigofood_user.token;
					this.uid = sigofood_user.uid;
					this.user_id = sigofood_user.user_id;
					console.log(this.token);
					console.log(this.uid);
					console.log(this.user_id);

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
				
			} else if(localStorage.getItem('sigofood_guest')){
				var sigofood_guest =  JSON.parse(localStorage.getItem('sigofood_guest'));
				console.log(sigofood_guest);
				if(sigofood_guest.token) {
					this.token = sigofood_guest.token;
					this.device_token = sigofood_guest.token;
					this.guest_id = sigofood_guest.guest_id;
					this.uid = "";
					console.log(this.device_token);
					console.log(this.guest_id);
					

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			}else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
      	}, 

		  getLocation() {
			if (localStorage.getItem('sigofood_location')) {
				var sigofood_location =  JSON.parse(localStorage.getItem('sigofood_location'));
				if(sigofood_location.block_no) {
					this.block_no = sigofood_location.block_no;
				} 
			}  else {
				this.$router.push({ name: "location" });
			}
		}, 

		fetchAddress() {
		// console.log(this.$route.params.address_id);
			this.getToken();
			let url = "address/details?address_id=" + this.$route.params.address_id + "&uid=" + this.uid + "&device_token=" + this.device_token;          
			this.loading = true;

			var config;
			if(this.uid) {
				config = {
					headers: {
						"Authorization": "Bearer " + this.token,
					},
				};
			} else {
				config = {
					headers: {
						
					},
				};
			}

			this.$axios
				.get(url, config)
				.then((res) => {
					console.log(res);
				if(res.status == 200) {
					var responseData = res.data.data;
					console.log(responseData);

					this.address = responseData;
					console.log(this.address);
					//alert(this.$route.params.address_id);
						this.latitude = this.address.latitude;
						this.longitude = this.address.longitude;
						console.log(this.latitude);
						console.log(this.longitude);
						this.marker.position.lat = parseFloat(responseData.latitude);
						this.marker.position.lng = parseFloat(responseData.longitude);

						this.center.lat = parseFloat(responseData.latitude);
						this.center.lng = parseFloat(responseData.longitude);

				} else {
					this.$swal("", "Something went wrong", "error");
				}
				
			})
			.catch((error) => {
				if (error.response) {
				if(error.response.status == 422) {               
					if (error.response.data) {
						this.errors = error.response.data.message;
					} 
					this.$swal("", error.response.statusText, "error");
					
				} else if(error.response.status == 500) {
					this.$swal("", error.response.statusText, "error");

				} else if(error.response.status == 401) {
					this.$swal("", error.response.statusText, "error");
					this.$router.push({ name: "login" });
					
				} else {
					this.$swal("", "Something went wrong", "error");
				}
				} else {
				this.$swal("", error.message, "error");
				}
			})
			.finally(() => (this.loading = false));
      	}, 

		getMapUrl() {
            return `https://maps.google.com/maps?q=${this.latitude},${this.longitude}&z=15&output=embed`;
        },

		fetchCart() {

         this.getToken();
         let url;         
         this.loading = true;

         var token;
         if(this.uid) {
         	token = this.token;
         	url = "cart/getData?uid=" + this.uid + "&device_token=" + this.device_token;
         } else {
         	token = this.token;
         	url  = "guest/getCartData"; 
         }

         this.$axios
            .get(url, { headers: { Authorization: "Bearer " + token } })
            .then((res) => {
            	console.log(res);
               if(res.status == 200) {
                  var responseData = res.data.data;
                  console.log(responseData);

                  this.cart = responseData;
                  this.subtotal = res.data.total;                  

               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                  
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
      }, 

      changeContactless() {
      	if(this.contactless == '1') {
      		this.payment_method = 2;
      	} else {
      		this.payment_method = 1;
      	}
      },

      changeCash() {
      	//alert(this.contactless);
      	if(this.contactless == '1') {
      		this.payment_method = 2;
      	} 
      },

		// place() {
		// 	this.place_order = false;
		// 	this.$bvModal.msgBoxConfirm('Are you sure you want to place this order?', {
		// 		title: 'Confirm',
		// 		size: 'sm',
		// 		buttonSize: 'sm',
		// 		okVariant: 'danger',
		// 		okTitle: 'Yes',
		// 		cancelTitle: 'No',
		// 		footerClass: 'p-2',
		// 		hideHeaderClose: false,
		// 		centered: true
		// 	})
		// 	.then(value => {
		// 		this.place_order = value
		// 		if(this.place_order){
		// 	}
		// 	})
		// 	.catch(err => {
		// 		console.log(err);
		// 	})
		// },

      	checkout() {


            this.getToken();           
	        var config;
				var grandtotal = this.subtotal;

				var datetime = '2002-02-02 ' + this.delivery_time; //dummy date
    			var delivery_time = moment.utc(datetime).format('hh:mm A');

            if(this.delivery_type == 'DoorDelivery') {
            	grandtotal = parseFloat(grandtotal) + parseFloat(this.cart[0].delivery_charge);
            }

            this.loading = true;
            if(this.uid) {
	            config = {
	               headers: {
	                  "Content-type": "multipart/form-data",
	                  "Accept": "application/json",
	                  "Authorization": "Bearer " + this.token,
	               },
	            };
				let url = "Checkout";
				let formData = new FormData();
				formData.append("device_token", this.device_token); 
				formData.append("address_id", this.$route.params.address_id);
				formData.append("restaurant_id", this.cart[0].r_id); 
				formData.append("payment_method", this.payment_method); 
				formData.append("delivery_notes", this.delivery_notes); 
				formData.append("offer_code", this.offer_code); 
				formData.append("branch_id", this.cart[0].branch_id); 
				formData.append("no_Cutlery", this.no_Cutlery); 
				formData.append("delivery_date", this.delivery_date); 
				formData.append("delivery_time", delivery_time); 
				formData.append("delivery_type", this.delivery_type); 
				formData.append("delivery_charge", this.cart[0].delivery_charge); 
				formData.append("service_charge", this.cart[0].service_charge);

				formData.append("subtotal", this.subtotal); 
				formData.append("grandtotal", grandtotal);
				formData.append("block_no", this.block_no);
			

				this.$axios
				.post(url, formData, config)
				.then((response) => {
					if (response.data.status==true) {
						// this.$swal("", response.data.message, "success");
						// this.$router.push({ name: 'home'});	

						//this.showSuccessMessage();
						if(this.payment_method == 2) {
							this.createPayment(response.data.order_id, grandtotal);
						} else {
							this.$router.push({ name: 'order-success'});
						}

					} else if(response.data.status==false){
							this.$swal("", response.data.message, "Failed");
							this.$router.push({ name: 'cart'});
					} else {
						this.$swal("", response.data.message, "error");
						this.$router.push({ name: 'home'});
            		}
                 
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
	        } else {
	         	config = {
	               headers: {
	                  "Content-type": "multipart/form-data",
	                  "Accept": "application/json",
	               },
	            };
				let url = "checkout";
          
				let formData = new FormData();
				formData.append("device_token", this.device_token); 
				formData.append("address_id", this.$route.params.address_id);
				formData.append("restaurant_id", this.cart[0].r_id); 
				formData.append("payment_method", this.payment_method); 
				formData.append("delivery_notes", this.delivery_notes); 
				formData.append("offer_code", this.offer_code); 
				formData.append("branch_id", this.cart[0].branch_id); 
				formData.append("no_Cutlery", this.no_Cutlery); 
				formData.append("delivery_date", this.delivery_date); 
				formData.append("delivery_time", delivery_time); 
				formData.append("delivery_type", this.delivery_type); 
				formData.append("delivery_charge", this.cart[0].delivery_charge); 
				formData.append("service_charge", this.cart[0].service_charge);

				formData.append("subtotal", this.subtotal); 
				formData.append("grandtotal", grandtotal);
				formData.append("block_no", this.block_no);
			

				this.$axios
				.post(url, formData, config)
				.then((response) => {
					if (response.data.status) {
						//this.$swal("", response.data.message, "success");
						//this.showSuccessMessage();
						if(this.payment_method == 2) {
							this.createPayment(response.data.order_id, grandtotal);
						} else {
							this.$router.push({ name: 'order-success'});
						}
						
					} else {
						this.$swal("", response.data.message, "error");
					}
					this.$router.push({ name: 'home'});
				})
				.catch((error) => {
					if (error.response) {
						if (error.response.data.message) {
							this.errors = error.response.data.message;
							//console.log(this.errors);
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				})
				.finally(() => (this.loading = false));
	        }
		},	

		createPayment(order_id, grandtotal) {

			var config = {
	               headers: {
	                  "Content-type": "multipart/form-data",
	                  "Accept": "application/json",
	               },
	      };
	      this.loading = true;

			let url = "Payment/create";
			let formData = new FormData();
			formData.append("order_id", order_id);
			formData.append("amount", grandtotal);			

			this.$axios
			.post(url, formData, config)
			.then((response) => {
				if (response.data.status == true) {
					console.log(response.data.data);
					if(response.data.data.transaction) {
						window.location.href = response.data.data.transaction.url;
					} else {
						this.$swal("", "Payment Failed", "Failed");
					}

				} else{
					this.$swal("", response.data.message, "Failed");
				} 
                 
         })
         .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
         })
         .finally(() => (this.loading = false));
		},

		showSuccessMessage()	{
			const h = this.$createElement
        				
			const messageVNode = h('div', { class: ['message-box'] }, 
			        		[
			          		h('p', { class: ['text-center'] }), 
			          			
			          	h('b-img', {
			           	 props: {
			              	src: '/design/sigofood-images/ordersuccess.png',
			              	center: true,
			              	fluid: true, 
			            	}
			          	}),
			          	h('h4', { class: ['text-center', 'text-theme'] }, ['Thank you for your order']), 
			])       				

        	this.$bvModal.msgBoxOk([messageVNode],{
          					title: '',
          					size: 'sm',
          					buttonSize: 'sm',
          					okVariant: 'warning',
          					okTitle: 'View Orders',
          					headerClass: 'p-2 border-0',
          					footerClass: 'border-0 success-footer',
          					centered: true,
          					bodyClass: 'success-msgbox',
        					})
          	.then(value => {
          		if(value) {
            		this.$router.push({ name: 'orders'});
            	}
          	})
          	.catch(err => {
            	console.log(err);
          	})					
		},

		applyCoupon(subtotal,offer_code) {
			this.getToken();           
            if (this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 

				const config = {
				headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer " + this.token,

				},
				};
	            
				let url = "checkout/checkCoupon";
				let formData = new FormData();
				formData.append("device_token", this.token); 
				formData.append("total", subtotal);
				formData.append("offer_code", offer_code); 

				this.$axios
				.post(url, formData, config)
				.then((res) => {
								if(res.status == 200) {
									var responseData = res.data;
									console.log(responseData);
									this.voucher_aaply = responseData;
									this.sub_total = res.data.total;
									this.messages = res.data.message;
									console.log(this.sub_total);

								} else {
									this.$swal("", "Something went wrong", "error");
								} 		
                 
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

			} else {

				const config = {
					headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer ",

				},
	            };

				let url = "checkout/checkCoupon";
				let formData = new FormData();
				formData.append("device_token", this.device_token); 
				formData.append("total", subtotal);
				formData.append("offer_code", offer_code); 

				this.$axios
				.post(url, formData, config)
				.then((res) => {
								if(res.status == 200) {
									var responseData = res.data;
									console.log(responseData);
									this.voucher_aaply = responseData;
									this.sub_total = res.data.total;
									this.messages = res.data.message;
									console.log(this.sub_total);

								} else {
									this.$swal("", "Something went wrong", "error");
								} 		
                 
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

			}   

	        
		}	
        
	}
}
</script>
